import React from 'react';
import { settingMap } from './config';

const renderManual = (props) => (
  <div className="sec manual-sec">
    <div className="card">
      <div className="panel base-set fe-flex-spacebetween">
        <em className="tt">您在线索管理模块中手动分配线索即可，无需设置规则</em>
        {props.type != settingMap[0].key && window.pageProps.xundaOuterCode === 0 ? (
          <a
            href="javascript:void(0);"
            className="edit"
            onClick={() => {
              props.apply(settingMap[0].key);
            }}
          >
            应用规则
          </a>
        ) : null}
      </div>
    </div>
  </div>
);

export default renderManual;
